<!--<app-header></app-header>-->
<!--&lt;!&ndash; Page content &ndash;&gt;-->
<!--<div class="page-content">-->
  <!--&lt;!&ndash; Main content &ndash;&gt;-->
  <!--<div class="content-wrapper">-->
    <!--&lt;!&ndash;<app-header></app-header>&ndash;&gt;-->
    <!--<router-outlet></router-outlet>-->
    <!--<app-footer></app-footer>-->
  <!--</div>-->
<!--</div>-->

<app-header></app-header>
<div class="page-content">
  <app-left-display  class="sidebar sidebar-dark sidebar-main sidebar-expand-md"></app-left-display>
  <div class="content-wrapper">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
</div>